import React from "react";
import EBooks from "../EBooks";
import "../../Styling/NavEBooks.css";
const EBooksNav = () => {
  return (
    <div className="ebooks">
      <EBooks />
    </div>
  );
};

export default EBooksNav;
